import { render } from "./StepFormComponent.vue?vue&type=template&id=20c9d8f5&scoped=true"
import script from "./StepFormComponent.vue?vue&type=script&lang=js"
export * from "./StepFormComponent.vue?vue&type=script&lang=js"

import "./StepFormComponent.vue?vue&type=style&index=0&id=20c9d8f5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c9d8f5"]])

export default __exports__